import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
var Field = /*#__PURE__*/function (_React$Component) {
  function Field(props) {
    var _this;
    _classCallCheck(this, Field);
    _this = _callSuper(this, Field, [props]);
    _this.componentDidUpdate = function (prevProps) {
      if (_this.props.focused) {
        _this.search.setSelectionRange(_this.state.cursorStart, _this.state.cursorEnd);
      }
      var prevFocus = prevProps.focus;
      var _this$props = _this.props,
        focus = _this$props.focus,
        currentValue = _this$props.currentValue;
      if (focus && prevFocus !== focus) {
        _this.search.focus();
      }
      if (currentValue !== _this.state.value) {
        _this.setState({
          value: typeof currentValue == 'string' ? currentValue : currentValue === null || currentValue === void 0 ? void 0 : currentValue.title
        });
      }
    };
    _this.state = {
      value: '',
      cursorStart: null,
      cursorEnd: null
    };
    _this.search;
    _this.bindings = {
      onChange: _this.onChange.bind(_this),
      onFocus: _this.onFocus.bind(_this),
      onBlur: _this.onBlur.bind(_this),
      onKeyDown: _this.onKeyDown.bind(_this),
      onClick: _this.onClick.bind(_this)
    };
    return _this;
  }
  _inherits(Field, _React$Component);
  return _createClass(Field, [{
    key: "onChange",
    value: function onChange(event) {
      var _this2 = this;
      this.setState({
        value: event.currentTarget.value,
        cursorStart: this.search.selectionStart,
        cursorEnd: this.search.selectionEnd
      }, function () {
        _this2.props.onChange(_this2.state.value);
      });
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.setState({
        cursorStart: this.search.selectionStart,
        cursorEnd: this.search.selectionEnd
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.props.onFocus();
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.props.onBlur();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var keyCode = {
        enter: 13,
        esc: 27,
        left: 37,
        up: 38,
        right: 39,
        down: 40
      };
      switch (event.keyCode) {
        case keyCode.enter:
          event.currentTarget.blur();
          this.props.onApply('current');
          break;
        case keyCode.esc:
          this.props.onReset();
          break;
        case keyCode.up:
          if (this.props.onSelect('prev')) {
            event.preventDefault();
            if (event.currentTarget.setSelectionRange) {
              var cleanRange = 999;
              event.currentTarget.setSelectionRange(cleanRange, cleanRange);
            }
          }
          break;
        case keyCode.left:
          this.setState({
            cursorStart: this.search.selectionStart,
            cursorEnd: this.search.selectionEnd
          });
          break;
        case keyCode.right:
          this.props.onSelect('current');
          this.setState({
            cursorStart: this.search.selectionStart,
            cursorEnd: this.search.selectionEnd
          });
          break;
        case keyCode.down:
          this.props.onSelect('next');
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("div", null, this.props.showCurrentSuggestion && /*#__PURE__*/React.createElement("input", {
        type: "text",
        value: this.props.currentSuggestion,
        readOnly: true
      }), /*#__PURE__*/React.createElement("input", {
        type: "text",
        placeholder: this.props.placeholder,
        value: this.state.value,
        onChange: this.bindings.onChange,
        onFocus: this.bindings.onFocus,
        onClick: this.bindings.onClick,
        onBlur: this.bindings.onBlur,
        onKeyDown: this.bindings.onKeyDown,
        autoFocus: this.props.focus,
        "data-aut-id": "searchBox",
        ref: function ref(c) {
          _this3.search = c;
        }
      })));
    }
  }]);
}(React.Component);
Field.defaultProps = {
  currentSuggestion: '',
  currentValue: '',
  focus: false,
  showCurrentSuggestion: false
};
export default Field;